export default __webpack_public_path__ + "static/media/process2.3eb1124a.webp";